<span class="flex justify-center leading-none border rounded-3xl chipsize-{{ size }} chipbg-{{ color }}">
    <span class="font-normal tracking-wide text-gray-100">
        <ng-content></ng-content>
    </span>
</span>